// Constants
import { KeyCode } from "@ms/uno-constants/lib/local/KeyCode";
// Controls
import { DocumentPreviewIcon } from "../documentPreviewIcon/DocumentPreviewIcon";
import { TaskAttachmentRowItem } from "@ms/uno-models/lib/local/client/taskAttachment/TaskAttachmentRowItem";
// Styles
import { documentPreviewIconsOverrides, getDocumentPreviewIconStyles } from "./DocumentPreview.styles";
// Utilities
import * as React from "react";
import { useTheme } from "@fluentui/react";
import { KeyboardUtilities } from "@ms/uno-utilities/lib/local/KeyboardUtilities";
/**
 * Component that wraps the Document preview on the Task Card
 */ export const DocumentPreview = /*#__PURE__*/ React.memo((props)=>{
    const { attachment, isFocusable, onAttachmentClick, onKeyDown } = props;
    const theme = useTheme();
    const taskAttachmentRowItem = TaskAttachmentRowItem.builder.fromTaskAttachment(attachment, "").build();
    const fileType = taskAttachmentRowItem.taskAttachmentRowItemType.taskAttachmentType;
    const customStyle = getDocumentPreviewIconStyles(theme, fileType);
    /* eslint-disable jsx-a11y/anchor-is-valid */ return /*#__PURE__*/ React.createElement("a", {
        className: "referencePreviewDescription",
        title: taskAttachmentRowItem.url,
        "data-is-focusable": isFocusable,
        tabIndex: isFocusable ? 0 : -1,
        onKeyDown: (evt)=>{
            const key = KeyboardUtilities.getKey(evt);
            if (key === KeyCode.ENTER || key === KeyCode.SPACE) {
                onAttachmentClick(taskAttachmentRowItem.url, evt);
            }
            onKeyDown(evt);
        },
        onClick: (evt)=>onAttachmentClick(taskAttachmentRowItem.url, evt)
    }, /*#__PURE__*/ React.createElement(DocumentPreviewIcon, {
        key: taskAttachmentRowItem.url,
        styles: customStyle,
        taskAttachmentRowItem: taskAttachmentRowItem,
        className: "previewIcon",
        icons: documentPreviewIconsOverrides
    }), /*#__PURE__*/ React.createElement("span", {
        className: "previewCaption"
    }, taskAttachmentRowItem.alias));
});
